import React from 'react';
import { CheckCircle2, XCircle, Eye, ExternalLink, FileText } from 'lucide-react';

export default function DocumentsSection({ documentos, onDocumentoValidation }) {
  return (
    <div className="mt-6 bg-[#2A2A2A] border border-white/10 rounded-lg p-6" data-testid="documents-section">
      <h2 className="font-heading text-xl text-[white] font-semibold mb-4">Gestión de Documentos</h2>
      {!documentos || documentos.length === 0 ? (
        <div className="flex flex-col items-center justify-center py-8 text-center">
          <FileText className="w-12 h-12 text-[#666666] mb-3" />
          <p className="text-[#666666] text-sm">No hay documentos registrados</p>
          <p className="text-[#666666] text-xs mt-1">Los documentos aparecerán aquí cuando el cliente los suba</p>
        </div>
      ) : (
        <div className="space-y-3">
          {documentos.map((doc, index) => (
            <div 
              key={index} 
              className="flex items-center justify-between p-4 bg-[#1A1A1A] border border-white/10 rounded-lg hover:border-white/20 transition-colors"
              data-testid={`document-${index}`}
            >
              <div className="flex-1">
                <p className="text-[white] font-body font-medium">{doc.nombre}</p>
                <p className="text-xs text-[#666666] mt-1">
                  Estado: <span className={
                    doc.estado === 'validado' ? 'text-[#10B981]' : 
                    doc.estado === 'rechazado' ? 'text-[#EF4444]' : 
                    'text-[#F59E0B]'
                  }>
                    {doc.estado}
                  </span>
                </p>
                {doc.url && (
                  <p className="text-xs text-[#3B82F6] mt-1 flex items-center gap-1">
                    <ExternalLink className="w-3 h-3" />
                    Documento cargado en Strapi
                  </p>
                )}
              </div>
              <div className="flex gap-2">
                {doc.url && (
                  <a
                    href={doc.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="p-2 hover:bg-[#3B82F6]/20 rounded-lg transition-colors"
                    title="Ver documento"
                    data-testid={`view-doc-${index}`}
                  >
                    <Eye className="w-5 h-5 text-[#3B82F6]" />
                  </a>
                )}
                <button
                  onClick={() => onDocumentoValidation(index, true)}
                  className="p-2 hover:bg-[#10B981]/20 rounded-lg transition-colors"
                  title="Validar documento"
                  data-testid={`validate-doc-${index}`}
                >
                  <CheckCircle2 className="w-5 h-5 text-[#10B981]" />
                </button>
                <button
                  onClick={() => onDocumentoValidation(index, false)}
                  className="p-2 hover:bg-[#EF4444]/20 rounded-lg transition-colors"
                  title="Rechazar documento"
                  data-testid={`reject-doc-${index}`}
                >
                  <XCircle className="w-5 h-5 text-[#EF4444]" />
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
